module.exports = __webpack_public_path__ + "img/car_00024.ae312576.jpg";